import React, { useEffect, useState } from "react";
import PlusIcon from "../../assets/icons/plus";
import Popup from "../Common/Popup";
import Input from "../Common/CustomInput";
import useApiLoader from "../../Utils/useApiLoader";
import Loader from "../Loader/Loader";
import api from "../../setupMiddleware";
import DesignationTable from "../Common/DesignationTable";
import CustomSelect from "../Common/CustomSelect";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { hasPermission } from "../../Utils/auth";

const DesignationManagement = () => {
  const [open, setOpen] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [designationData, setDesignationData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [newDes, setNewDes] = useState({
    department_id: null,
    title: "",
  });
  const [editDes, setEditDes] = useState({});

  const { department_id, title } = newDes;

  const loading = useApiLoader();

  const departmentOptions = departmentData?.map((dep) => ({
    label: dep.name,
    value: dep.id,
  }));

  const getAllDesignations = async () => {
    api.get("/api/designations").then((res) => {
      if (res && res.status === 200) {
        setDesignationData(res.data);
        setOpen(false);
        setEditOpen(false);
      }
    });
  };

  const getAllDepartments = async () => {
    api.get("/api/departments").then((res) => {
      if (res && res.status === 200) {
        setDepartmentData(res.data);
      }
    });
  };

  useEffect(() => {
    getAllDesignations();
    getAllDepartments();
  }, []);

  const addNewDesignation = async () => {
    if (!department_id || !title) {
      alert("Please enter Title and select Department to add Designation");
      return;
    }
    api
      .post("/api/designations", { title, department_id })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllDesignations();
        }
      })
      .catch((err) => {
        if (err) {
          toast.error(err.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      });
  };

  const handleEditDesignation = (val) => {
    setEditDes(val);
    setEditOpen(true);
  };

  const updateDesignation = async () => {
    if (!editDes?.id || !editDes?.title) {
      alert("Please enter Title and select Department to add Designation");
      return;
    }
    api
      .put(`/api/designations/${editDes?.id}`, {
        title: editDes?.title,
        department_id: editDes?.id,
      })
      .then((res) => {
        if (res && res.status === 200) {
          toast.success(res.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          getAllDesignations();
        }
      })
      .catch((err) => {
        if (err) {
          toast.error(err.response?.data?.message, {
            position: "top-left",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
        }
      });
  };

  return (
    <>
      {loading && <Loader opacity={90} />}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center w-full mx-auto px-4 py-3 gap-4">
        {/* Left Content */}
        <p>
          <span className="block text-xl sm:text-2xl font-medium text-[#de2b26]">
            Designation Management
          </span>
          <span className="block text-sm text-[#142b70]/50">
            Manage All Designations
          </span>
        </p>

        {/* Right Button */}
        <div className="flex">
          {hasPermission("add_designations") && (
            <button
              onClick={() => setOpen(true)}
              className="flex items-center gap-2 px-4 py-2 rounded bg-[#de2b26] hover:bg-[#c30f0a] transition text-white text-sm font-medium"
            >
              <PlusIcon iconClass="w-4 h-4" color="#ffffff" />
              Add New Designation
            </button>
          )}
          <Popup
            isOpen={open}
            onClose={() => setOpen(false)}
            title="Add New Designation"
          >
            <div className="flex flex-col gap-6 mt-[30px] mb-10">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Title</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Enter Designation Title"
                    value={title}
                    onChange={(e) =>
                      setNewDes({ ...newDes, title: e.target.value })
                    }
                  />
                </div>
              </div>
              {/* <div className="flex flex-col gap-2 mb-10">
                <p className="text-sm text-[#142b70]/80">Department</p>
                <CustomSelect
                  options={departmentOptions}
                  value={department_id}
                  placeholder="Department"
                  width="w-full"
                  height="h-[46px]"
                  fontSize="14px"
                  onChange={(op) =>
                    setNewDes({
                      ...newDes,
                      department_id: op.value,
                    })
                  }
                />
              </div> */}
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium"
                onClick={addNewDesignation}
              >
                Add New Designation
              </button>
            </div>
          </Popup>
          {/* Edit Popup */}
          <Popup
            isOpen={editOpen}
            onClose={() => setEditOpen(false)}
            title="Edit Designation"
          >
            <div className="flex flex-col gap-6 mt-[30px] mb-10">
              <div className="flex flex-col gap-2">
                <p className="text-sm text-[#142b70]/80">Title</p>
                <div className="relative">
                  <Input
                    type="text"
                    placeholder="Enter Designation Title"
                    value={editDes?.title}
                    onChange={(e) =>
                      setEditDes({ ...editDes, title: e.target.value })
                    }
                  />
                </div>
              </div>
              {/* <div className="flex flex-col gap-2 mb-10">
                <p className="text-sm text-[#142b70]/80">Department</p>
                <CustomSelect
                  options={departmentOptions}
                  value={editDes?.id}
                  placeholder="Department"
                  width="w-full"
                  height="h-[46px]"
                  fontSize="14px"
                  onChange={(op) =>
                    setEditDes({
                      ...editDes,
                      id: op.value,
                    })
                  }
                />
              </div> */}
            </div>
            {/* Footer */}
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setEditOpen(false)}
                className="px-10 py-3.5 rounded-md border border-[#de2b26] text-[#de2b26] font-medium"
              >
                Cancel
              </button>
              <button
                className="px-10 py-3.5 rounded-md bg-[#de2b26] text-white font-medium"
                onClick={updateDesignation}
              >
                Update Designation
              </button>
            </div>
          </Popup>
        </div>
      </div>

      <div className="w-full mx-auto px-4 py-3 relative">
        <div className="w-full mx-auto px-4 py-3 relative rounded-xl bg-white border border-[#a48572]/10">
          <div className="flex flex-col justify-start items-start gap-[20px]">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 relative gap-5">
              <p className="flex-grow-0 flex-shrink-0 text-base font-medium text-left text-[#142b70]">
                All Designation
              </p>
            </div>
            <DesignationTable
              data={designationData}
              handleEdit={handleEditDesignation}
            />
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default DesignationManagement;
